/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";

export const CloseIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" stroke="#333" strokeLinecap="square" strokeWidth="2">
        <path d="M16.95 6.914l-9.9 9.9M16.95 17.107l-9.9-9.9"></path>
      </g>
    </svg>
  );
};
